'use strict';
var _ = require('lodash');

function getApplicationPath () {
    var appPath = window.NOA ? (window.NOA.applicationPath || '/') : '/';
    return appPath + (_.endsWith(appPath, '/') ? '' : '/');
}

module.exports = {
    getApplicationPath: getApplicationPath,
    getRoot: function () {
        return window.NOA ? window.NOA.applicationPath : '/';
    },
    getLogOffUrl: function()
    {
        return getApplicationPath() + 'Account/LogOff'
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./services/UrlService.js